var exports = {
  "Pc": "MemeFormFields.module__tagsContainer___MEhtYj",
  "Pr": "MemeFormFields.module__tagsHeader___MEhtYj",
  "ft": "MemeFormFields.module__tagsHeaderLabel___MEhtYj",
  "C_": "MemeFormFields.module__tagsInputRow___MEhtYj",
  "Cs": "MemeFormFields.module__tagsList___MEhtYj",
  "r3": "MemeFormFields.module__tagChip___MEhtYj",
  "xH": "MemeFormFields.module__tagRemoveButton___MEhtYj",
};

module.exports = exports;
